import MagicWand from "../../../../icons/MagicWand";
import { Button, Spinner } from "reactstrap";
import { AutomaticallySummarize } from "../AutomaticallySummarize";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { generateSummary } from "../../../../store/summarization/actions";
import { useAutomaticSummarization } from "../../../../hooks/useAutomaticSummarization";
import "./style.scss";

export const GenerateSummary = ({ messageId, conversationId, isDisabled }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const status = useSelector((state) => state.Summarization.generate_summary);
  const { isAutomaticallyGenerateSummaryEnabled } = useAutomaticSummarization();
  const [isLoading, setIsLoading] = useState(false);

  const disabled = useMemo(
    () => status.loading || isDisabled,
    [status.loading, isDisabled]
  );

  const handleGenerateSummary = useCallback(async () => {
    setIsLoading(true);
    dispatch(generateSummary({ messageId, conversationId }));
  }, [messageId, conversationId, dispatch]);


  useEffect(() => {
    if (status.success || status.error) setIsLoading(false)
  }, [status, dispatch, t]);

  useEffect(() => {
    if (!isAutomaticallyGenerateSummaryEnabled || isDisabled) return;
    handleGenerateSummary();
  }, [
    isAutomaticallyGenerateSummaryEnabled,
    handleGenerateSummary,
    isDisabled,
  ]);

  if (isLoading) {
    return (
      <div className="summary-chat-container">
        <div className="loading-container">
          <Spinner
            animation="border"
            size="sm"
            color="#556EE6"
            style={{ color: "#556EE6" }}
          />
          {t("Reading in progress...")}
        </div>
      </div>
    );
  }

  return (
    <div className="summary-chat-container">
      <Button
        onClick={handleGenerateSummary}
        className="btn-generate-summary"
        color="primary"
        disabled={disabled}
      >
        {t("Summarize conversation")} <MagicWand />
      </Button>
      <AutomaticallySummarize isDisabled={disabled} />
    </div>
  );
};
